module.exports = __webpack_public_path__ + "static/img/TPE_LOGO.12e4e47.png";